var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCellarIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 2.5C12.5 3.88 11.38 5 10 5C8.62 5 7.5 3.88 7.5 2.5C7.5 1.12 8.62 0 10 0C11.38 0 12.5 1.12 12.5 2.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99997 8.59L3.63997 2.22L2.21997 3.64L8.58997 10L2.22997 16.36L3.63997 17.77L9.99997 11.41L16.36 17.77L17.77 16.36L11.41 10L17.77 3.64L16.36 2.23L9.99997 8.59Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 10C20 8.62 18.88 7.5 17.5 7.5C16.12 7.5 15 8.62 15 10C15 11.38 16.12 12.5 17.5 12.5C18.88 12.5 20 11.38 20 10Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 10C5 8.62 3.88 7.5 2.5 7.5C1.12 7.5 0 8.62 0 10C0 11.38 1.12 12.5 2.5 12.5C3.88 12.5 5 11.38 5 10Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 17.5C12.5 18.88 11.38 20 10 20C8.62 20 7.5 18.88 7.5 17.5C7.5 16.12 8.62 15 10 15C11.38 15 12.5 16.12 12.5 17.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCellarIcon);
export default __webpack_public_path__ + "static/media/cellarIcon.0ba75a106c9ed273abedecd25f7e3f89.svg";
export { ForwardRef as ReactComponent };